// angular
import { NgOptimizedImage } from '@angular/common';
import {Component, effect, inject, input, OnInit} from "@angular/core";
import { TranslateModule } from '@ngx-translate/core';
// components
import { ChatLanguagesDialogComponent } from '@app/core/dialogs/chat-languages-dialog/chat-languages-dialog.component';
// services
import { StateManagementService } from '@app/+chat/shared/services/state-management.service';
import { DialogService } from '@app/core/shared/services/dialog.service';
import { StorageService } from '@app/shared/services/storage.service';
// interfaces & constants & pipes
import { IBusiness } from '@app/+suppliers/shared/interfaces/business.interface';
import { LanguagesCodesType } from '@app/+chat/shared/types/languages-codes.type';
import { LanguageCodes } from '@app/shared/constants/language-codes.const';
import { ImageSourcePipe } from '@app/shared/pipes/image-source.pipe';
import {MessagingService} from "@app/+chat/shared/services/messaging.service";

@Component({
  selector: 'pwj-chat-options',
  standalone: true,
  imports: [
    NgOptimizedImage,
    TranslateModule,
    ImageSourcePipe,
  ],
  templateUrl: './chat-options.component.html',
  styleUrl: './chat-options.component.scss',
})
export class ChatOptionsComponent implements OnInit {
  public selectedChatLang!: string;
  public currentLanguage!: string;
  public languageCodes: LanguagesCodesType[] = LanguageCodes;

  // inputs
  isSupportChatMod = input<boolean>(false);
  businessChatData = input.required<IBusiness>();

  // dependencies
  private readonly _stateManagementService = inject(StateManagementService);
  private readonly _storageService = inject(StorageService);
  private readonly _dialogService = inject(DialogService);
  private readonly _messagingService = inject(MessagingService);

  constructor() {
    // update chat language
    effect(() => {
      this.selectedChatLang =
        this._stateManagementService.currentChatLanguage();
      this.setCurrentLanguage();
    });
  }

  ngOnInit(): void {
    // get chat current language
    this.selectedChatLang = this._storageService.getChatLang();
    this.setCurrentLanguage();
  }

  public openChatLanguages() {
    // open chat languages menu dialog and select a language for chat messages translations
    const dialogRef = this._dialogService.open(ChatLanguagesDialogComponent, {
      width: 'none',
      height: '28em',
    });

    dialogRef.afterClosed().subscribe(res => {
      if (res?.changeLanguage) {
        // set current chat language functionality
        this.setCurrentLanguage();
        // get all messages
        if (this._stateManagementService.oneChatById()?._id){
          this._messagingService.getAllMessages(this._stateManagementService.oneChatById()?._id as string);
        }
      }
    });
  }

  public getLanguageName(code: string) {
    // get language name from mock data & show that in ui
    return this.languageCodes.find(language =>
      language.lang_iso_code.includes(code)
    )?.language_form;
  }

  public setCurrentLanguage() {
    this.currentLanguage = this.getLanguageName(this.selectedChatLang) || '';
  }
}
